<template>
  <div class="basic-info">
    <el-form
      label-position="left"
      label-width="6rem"
      :rules="rules"
      :model="createTenant"
      ref="createTenant"
      v-if="tenants.length == 0 || (isEdit && operation == 'create')"
    >
      <div class="edit-view">
        <div class="title">
          <div v-if="operation == 'create'">添加新租户</div>
          <div v-else>基本信息</div>
        </div>
        <el-form-item label="租户名称" prop="name">
          <el-input
            v-model="createTenant.name"
            placeholder="请输入租户名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="别名" prop="displayName">
          <el-input
            v-model="createTenant.displayName"
            placeholder="请输入别名"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="管理员用户名" prop="adminUserName">
          <el-input v-model="createTenant.adminUserName" placeholder="请输入管理员用户名"></el-input>
        </el-form-item> -->
        <el-form-item label="管理员姓名" prop="adminName">
          <el-input
            v-model="createTenant.adminName"
            placeholder="请输入管理员姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="管理员邮箱" prop="adminEmail">
          <el-input
            v-model="createTenant.adminEmail"
            placeholder="请输入管理员邮箱"
          ></el-input>
        </el-form-item>
        <el-form-item label="管理员手机号" prop="adminPhoneNumber">
          <el-input
            v-model="createTenant.adminPhoneNumber"
            placeholder="请输入管理员手机号"
          ></el-input>
        </el-form-item>
        <el-form-item label="管理员密码" prop="adminPassword">
          <el-input
            v-model="createTenant.adminPassword"
            placeholder="请输入管理员密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="租户版本" prop="editionId">
          <el-select
            v-model="createTenant.editionId"
            placeholder="请选择租户版本"
            class="handle-select"
          >
            <el-option
              v-for="item in editionList"
              :key="item.id"
              :label="item.displayName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <div class="create-btn">
          <el-button type="primary" @click="createSubmit('createTenant')"
            :loading="isLoading">保存</el-button
          >
          <el-button @click="cancel">取消</el-button>
        </div>
      </div>
    </el-form>
    <el-form
      label-position="left"
      label-width="5rem"
      :rules="rules"
      :model="updateTenantInfo"
      v-else-if="isEdit && operation !== 'create'"
      ref="updateTenantInfo"
    >
      <div class="edit-view">
        <div class="title">
          <div>基本信息</div>
        </div>
        <el-form-item label="租户名称" prop="name">
          <el-input
            v-model="updateTenantInfo.name"
            placeholder="请输入租户名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="别名" prop="displayName">
          <el-input
            v-model="updateTenantInfo.displayName"
            placeholder="请输入别名"
          ></el-input>
        </el-form-item>
        <el-form-item label="租户版本" prop="editionId">
          <el-select
            v-model="updateTenantInfo.editionId"
            placeholder="请选择租户版本"
            class="handle-select"
          >
            <el-option
              v-for="item in editionList"
              :key="item.id"
              :label="item.displayName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <div class="update-btn">
          <el-button type="primary" @click="editInfo('updateTenantInfo')" :loading="isLoading"
            >保存</el-button
          >
          <el-button @click="cancel">取消</el-button>
        </div>
      </div>
    </el-form>
    <el-form
      label-position="left"
      label-width="6rem"
      :rules="rules"
      :model="tenantUpdataInfo"
      v-else
    >
      <div class="info-view">
        <div class="title">
          {{ tenantUpdataInfo.name }}
          <div class="edit-btn" @click="updateInfo">管理</div>
        </div>

        <el-form-item label="租户名称">{{
          tenantUpdataInfo.name
        }}</el-form-item>
        <el-form-item label="别名">{{
          tenantUpdataInfo.displayName| nullValue
        }}</el-form-item>
        <el-form-item label="租户版本">{{
          tenantUpdataInfo.editionName | nullValue
        }}</el-form-item>
      </div>
    </el-form>
  </div>
</template>

<script>
const validatePhoneNumber = (rule, value, callback) => {
  if (!value) {
    callback(new Error("请输入手机号"));
  } else if (!validatePhone(value)) {
    callback(new Error("手机号输入不正确"));
  } else {
    callback();
  }
};
const validateEmailNumber = (rule, value, callback) => {
  if (!value) {
    callback(new Error("请输入电子邮箱"));
  } else if (!validateEmail(value)) {
    callback(new Error("电子邮箱输入不正确"));
  } else {
    callback();
  }
};
import { validatePhone, validateEmail } from "@/utils/validate";
import { deepCopy } from "@/utils/deepCopy";
import {
  getTenants,
  deleteTenant,
  creatTenant,
  updateTenant,
} from "@/http/api/tenants";
import { getEditions } from "@/http/api/editions";
import bus from "@/utils/bus";

export default {
  props: {
    operation: { type: String }, //操作类型
    tenantInfo: { type: Object }, // 租户数据
  },
  data() {
    return {
      isEdit: false,
      tenantUpdataInfo: {},
      updateTenantInfo: {
        name: "",
        displayName:"",
        editionId: "",
      },
      createTenant: {
        adminUserName: "",
        adminName: "",
        adminEmail: "",
        adminPhoneNumber: "",
        adminPassword: "",
        name: "",
        editionId: "",
      },
      editionList: [],
      tenants: [],
      isLoading : false,
      rules: {
        name: [
          { required: true, message: "租户名称不能为空", trigger: "blur" },
        ],
        displayName: [
          { required: true, message: "租户别名不能为空", trigger: "blur" },
        ],
        adminUserName: [
          { required: true, message: "管理员用户名不能为空", trigger: "blur" },
        ],
        adminName: [
          { required: true, message: "管理员姓名不能为空", trigger: "blur" },
        ],
        adminPassword: [
          { required: true, message: "管理员密码不能为空", trigger: "blur" },
        ],
        adminPhoneNumber: [
          { required: true, trigger: "blur", validator: validatePhoneNumber },
        ],
        adminEmail: [
          { required: true, trigger: "blur", validator: validateEmailNumber },
        ],
      },
      permissions: this.$store.getters.permissions, //用户权限集合
    };
  },
  watch: {
    operation(newV, oldV) {
      if (newV == "create") {
        this.isEdit = true;
      } else {
        this.isEdit = false;
      }
      //console.log(newV, oldV, "huoqude xinjiuzhi");
    },
    tenantInfo(newVal, oldVal) {
      this.tenantUpdataInfo = deepCopy(this.tenantInfo);
      this.updateTenantInfo = deepCopy(this.tenantInfo);
    },
  },
  mounted() {
    //console.log(this.tenantInfo, "zhelishigroupInfo");
    this.getTenantList();
    this.getEditionList();
  },
  methods: {
    getTenantList() {
      getTenants().then((res) => {
        this.tenants = res.result.items;
      });
    },
    getEditionList() {
      var query = {
        maxResultCount: 50,
      };
      getEditions(query).then((res) => {
        this.editionList = res.result.items;
      });
    },
    updateInfo() {
      if (this.permissions["RocketSaas.Tenants.Update"]) {
        this.isEdit = true;
        this.updateTenantInfo = deepCopy(this.tenantInfo);
        //console.log(this.tenantInfo, "获取的管理数据");
      } else {
        this.$message.warning({
          message: `您暂无管理租户权限`,
          showClose: true,
        });
      }
    },
    createSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.isLoading = true
          this.createTenant.adminUserName = this.createTenant.adminPhoneNumber;
          creatTenant(this.createTenant)
            .then((res) => {
              if(res.code == 10200){
              this.$emit("newTenantInfo", this.createTenant);
              bus.$emit('TenantsChange','租户改变');
              this.$message({
                message: res.message,
                type: "success",
              });
              this.getTenantList();
              this.isEdit = false;
              this.createTenant = {
                adminUserName: "",
                adminName: "",
                adminEmail: "",
                adminPhoneNumber: "",
                adminPassword: "",
                name: "",
                editionId: "",
              };
              }
              this.isLoading = false
            })
            .catch((err) => {
              this.isLoading = false
            });
        } else {
          //console.log("表单验证未通过");
          return false;
        }
      });
    },
    editInfo(formName) {
      //console.log(this.tenantUpdataInfo, "获取的this.tenantUpdataInfo");
      var data = {
        name: this.updateTenantInfo.name,
        displayName: this.updateTenantInfo.displayName,
        editionId: this.updateTenantInfo.editionId,
      };
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.isLoading = true
          updateTenant(this.updateTenantInfo.id, data)
            .then((res) => {
              if(res.code == 10200){
              this.$emit("updateTenantInfo", data);
              bus.$emit('TenantsChange','租户改变');
              this.$message({
                message: res.message,
                type: "success",
              });
              }
              this.isLoading = false
              this.isEdit = false;
            })
            .catch((err) => {
              this.$message({
                message: err.message,
              });
              this.isLoading = false
            });
        } else {
          //console.log("表单验证未通过");
          return false;
        }
      });
    },
    cancel() {
      this.isEdit = false;
      this.$emit("newTenantInfo", this.tenantInfo);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/mixin.scss";
.basic-info {
  padding: 20px 15px 10px 18px;
  text-align: left;

  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;

    margin: 20px 0;
    font-size: 14px;
    font-weight: bold;
    line-height: 14px;
    color: #000;

    .edit-btn {
      font-size: 12px;
      font-weight: 400;
      color: $--color-primary;
      cursor: pointer;
    }
  }
  .info-view {
    .el-form-item {
      margin-bottom: 2px;
    }
  }

  .edit-view {
    .el-form-item {
      margin-bottom: 20px;
      width: 425px;

      .name-tip {
        margin-top: 7px;
        font-size: 12px;
        font-weight: 400;
        line-height: 14px;
        color: #888;
      }
      // ::v-deep .el-form-item__content{
      //   @include flex (row,center);
      // }
      .el-select,
      .el-input {
        width: 330px;
      }
      .tip-svg {
        position: relative;
        top: -1px;
        margin-left: 5px;
        width: 14px;
        height: 14px;
        color: #9e9e9e;
      }
    }

    .create-btn {
      margin: 12px 0 0 6rem;
    }
    .update-btn {
      margin: 12px 0 0 5rem;
    }
  }
}
// ::v-deep .custom-tooltip {
//   .custom-tip {
//     padding: 5px;
//   }
// }
</style>
// <style lang="scss">
// .custom-tooltip {
//   .custom-tip {
//     padding: 5px;
//   }
// }
//
</style>